/**
 * Creates a GeoJSON FeatureCollection object.
 * @param {Array} features - An array of GeoJSON Feature objects.
 * @returns {Object} A GeoJSON FeatureCollection object.
 */
export const featureCollection = (features = []) => ({
  type: 'FeatureCollection',
  features,
});
